<div id="doc-container">
  @if (state === legalDocsState.Loading) {
    <div>Loading, please wait</div>
  }
  @if (state === legalDocsState.Loaded) {
    <div [innerHTML]="legalHtml"></div>
  }
  @if (state === legalDocsState.Error) {
    <div>{{ errorMessage }}</div>
  }
</div>
